import { TestId } from "../testIdType"
import { DialogSendButtonsKeys } from "../../../models/projectSettings"

export const testId: TestId = {
    addDialogTopicButton: "add-dialog-topic-button",
    addInMessageButton: "add-in-message-button",
    addNewUserChannel: "add-new-user-channel",
    addToMessageArticleButton: "add-to-message-article-button",
    AIAssistantCollapser: "ai-assistant-collapser",
    alertDialogCancel: "alert-dialog-cancel",
    alertDialogSubmit: "alert-dialog-submit",
    articleActions: "article-actions",
    attachmentCancel: "attachment-cancel",
    attachmentItem: "attachment-item",
    attachmentLink: "attachment-link",
    attachmentPreview: "attachment-preview",
    bulletListButton: "bullet-list-button",
    cancelButton: "cancel-button",
    cancelTransferDialogButton: "cancel-transfer-dialog-button",
    channel: "channel",
    clearSearchDialogsInput: "clear-search-dialogs-input",
    clientSurveyAccordion: "client-survey-accordion",
    clientSurveyAccordionToggle: "client-survey-accordion-toggle",
    closeViewAttachmentButton: "close-view-attachment-button",
    copyClientOrDialogIdButton: "copy-client-or-dialog-id-button",
    creatableTagSelectGroupHeading: "creatable-tag-select-group-heading",
    creatableTagSelectOption: "creatable-tag-select-option",
    creatableTagSelectTag: "creatable-tag-select-tag",
    createClientChannelUserId: "create-client-channel-user-id",
    customSectionAccordion: "custom-section-accordion",
    customSectionAccordionToggle: "custom-section-accordion-toggle",
    deleteDialogTopicButton: "delete-dialog-topic-button",
    deleteMessageAction: "delete-message-action",
    dialogAttachments: "dialog-attachments",
    dialogAttachmentsMoreFiles: "dialog-attachments-more-files",
    dialogAutoHolding: "dialog-auto-holding",
    dialogAutoHoldingCancelButton: "dialog-auto-holding-cancel-button",
    dialogBody: "dialog-body",
    dialogChat: "dialog-chat",
    dialogChatAction: "dialog-chat-action",
    dialogCreatingSubmitButton: "dialog-creating-submit-button",
    dialogFinishButton: "dialog-finish-button",
    dialogFinishCancelButton: "dialog-finish-cancel-button",
    dialogFooter: "dialog-footer",
    dialogHeader: "dialog-header",
    dialogHistoryListItem: "dialog-history-list-item",
    dialogList: "dialog-list",
    dialogListItem: "dialog-list-item",
    dialogListToggle: "dialog-list-toggle",
    dialogMessageViewButton: "dialog-message-view-button",
    dialogMessageViewCloseButton: "dialog-message-view-close-button",
    dialogPathSelectedChannel: "dialog-path-selected-channel",
    dialogPathChannelTooltip: "dialog-path-channel-tooltip",
    dialogLeftActions: "dialog-left-actions",
    dialogRightActionsDropdown: "dialog-right-actions-dropdown",
    dialogRightActionsMain: "dialog-right-actions-main",
    [DialogSendButtonsKeys.Hold]: "message-input_submit-and-hold-button",
    [DialogSendButtonsKeys.InternalMessage]: "message-input_send-internal-message",
    dialogStartButton: "dialog-start-button",
    dialogTimer: "dialog-badge-timer",
    dialogTransferModal: "dialog-transfer-modal",
    dialogTransferTabs: "dialog-transfer-tabs",
    dialogTransferModalSubmit: "dialog-transfer-modal-submit",
    dialogView: "dialog-view",
    dialogSearchFilterBtn: "dialog-search-filter-btn",
    downloadAttachmentButton: "download-attachment-button",
    downloadButton: "download-button",
    draggingArea: "dragging-area",
    dropPlace: "drop-place",
    dropPlaceContent: "drop-place-content",
    editedMessage: "edited-message",
    editMessageAction: "edit-message-action",
    emailAnswerModeActionToggleButton: "email-answer-mode-action-toggle-button",
    emailBCCButton: "email-bcc-button",
    emailBCCInput: "email-bcc-input",
    emailCCButton: "email-cc-button",
    emailCCInput: "email-cc-input",
    emailSubjectButton: "email-subject-button",
    emailSubjectInput: "email-subject-input",
    emailToInput: "email-to-input",
    emojiButton: "emoji-button",
    expandCollapseButton: "expand-collapse-button",
    expandEmailMessageAction: "expand-email-message-action",
    fastRepliesItem: "fast-reply-item",
    fastRepliesHotKeyCreateAction: "fast-reply-hotkey-create-action",
    fastRepliesHotKeyEditAction: "fast-reply-hotkey-edit-action",
    fastRepliesHotKeyDeleteAction: "fast-reply-hotkey-delete-action",
    fileSelectionButton: "file-selection-button",
    filesExportAccordion: "files-export-accordion",
    filesExportAccordionToggle: "files-export-accordion-toggle",
    forwardEmailAnswerMode: "forward-email-answer-mode",
    galleryBox: "gallery-box",
    galleryPreviewer: "gallery-previewer",
    galleryPreviewerContent: "gallery-previewer-content",
    imageFileSelectionButton: "image-file-selection-button",
    messageActionsButton: "message-actions-button",
    messageAttachmentsIncoming: "message-attachments-incoming",
    messageAttachmentsOutgoing: "message-attachments-outgoing",
    messageBasic: "message-basic",
    messageBasicAction: "message-basic-action",
    messageInput: "message-input",
    [DialogSendButtonsKeys.Message]: "message-input_submit-button",
    messagePinPreview: "message-pin-preview",
    messageReroute: "message-reroute",
    messageUserTyping: "message-user-typing",
    messageDeletedText: "message-deleted-text",
    nextAttachmentButton: "next-attachment-button",
    openArticleButton: "open-article-button",
    openCreatingOutgoingDialogButton: "open-creating-outgoing-dialog-button",
    openDialogHistoryIcon: "open-dialog-history-icon",
    openFastRepliesSidebarButton: "open-fast-replies-sidebar-button",
    openKBArticleById: "open-kb-article-by-id",
    openKnowledgeBaseSidebarButton: "open-knowledge-base-sidebar-button",
    openPreviousDialogInfoIcon: "open-previous-dialog-info-icon",
    operatorClientsList: "operator-clients-list",
    operatorClientsListItem: "operator-clients-list-item",
    operatorClientsListToggle: "operator-clients-list-toggle",
    operatorEmailChannel: "operator-email-channel",
    operatorsListFilter: "operators-list-filter",
    operatorsSelect: "operators-select",
    orderedListButton: "ordered-list-button",
    pinMessageAction: "pin-message-action",
    pinPreviewCloseButton: "pin-preview-close-button",
    previousAttachmentButton: "previous-attachment-button",
    queueIdOnOperatorRefused: "queue-id-on-operator-refused",
    quoteMessageAction: "quote-message-action",
    replaceButton: "replace-button",
    replyEmailAnswerMode: "reply-email-answer-mode",
    requestAIAssistByReqType: "request-ai-assist-by-req-type",
    resetCalendar: "reset-calendar",
    screenSharingAccordion: "screen-sharing-accordion",
    screenSharingAccordionToggle: "screen-sharing-accordion-toggle",
    searchDialogsButton: "search-dialogs-button",
    searchDialogsInput: "search-dialogs-input",
    sendArticleButton: "send-article-button",
    sendMessageAction: "send-message-action",
    setInputMaximizedButton: "set-input-maximized-button",
    showCalendar: "show-calendar",
    showDeletedMessageToggle: "show-deleted-message-toggle",
    showEditHistoryToggle: "show-edit-history-toggle",
    showMoreButton: "show-more-button",
    textToggle: "text-toggle",
    transferMessageTextarea: "transfer-message-textarea",
    xBtnClose: "x-btn-close",
    filesWithSectionsList: "files-with-sections-list",
    filesWithSectionsFile: "files-with-sections-file",
    filesWithSectionsShowMore: "files-with-sections-show-more",
    dialogFile: "dialog-file"
}
